import { json } from '../c-mp/fun/json'

export async function fetchPersonIdsWithImages() {
	const response = await fetch('/person-ids-with-images')
	if (!response.ok) {
		throw new Error(json`[tcg6yq] ${response.status} ${response.statusText}`)
	}
	const personIds: string[] = await response.json()
	return personIds
}
